import { Component } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { SubscriptionCancellationReasons } from '@app/constants/subscription-cancellation-reasons';

@Component({
    selector: 'app-subscription-cancellation-form',
    templateUrl: './subscription-cancellation.template.html',
})
export class SubscriptionCancellationForm extends BaseForm {
    reasons: string[] = SubscriptionCancellationReasons;
    reason: string = '';
    note: string = '';
}
